import { useEffect, useRef, useState } from "react";
import { DCarousel, DCarouselInternalData, DCarouselRef } from "@dfa/ui-platform";
import { Card } from "./types/card-carousel-types";
import CarouselNavigation from "./CarouselNavigation";
import { SCREEN_WIDTHS } from "components/utility/constants/screen_widths";
import {
	oneToOneResponsiveCards,
	standardResponsiveCards
} from "./settings/content-carousel-settings";
import StandardCard from "./cards/StandardCard";

type StandardCardData = {
	data: {
		cardTitle: string;
		containerCTA: {
			text: string;
			link: string;
		};
		isOneToOne: boolean;
		cards: Card[];
	};
};

const StandardCardCarousel = ({ data }: StandardCardData) => {
	const [internalCarouselData, setInternalCarouselData] = useState<DCarouselInternalData>();
	const [shortCarousel, setShortCarousel] = useState<boolean>(false);
	const carouselRef = useRef<DCarouselRef>(null);
	const carouselContainerRef = useRef<HTMLDivElement>(null);
	const isOneToOneCard = data.isOneToOne;
	const cardsLength = data.cards.length;
	const { LG, SM, XS } = SCREEN_WIDTHS;

	useEffect(() => {
		const screenSize = () => {
			if (cardsLength <= 4) {
				setShortCarousel(true);
			}
		};
		window.addEventListener("resize", screenSize);
		screenSize();
		return () => {
			window.removeEventListener("resize", screenSize);
		};
	}, [cardsLength, LG, SM, XS, isOneToOneCard]);

	return (
		<div
			className={`card-carousel-container${isOneToOneCard ? " one-to-one-cards" : ""}`}
			ref={carouselContainerRef}
		>
			<div className="carousel-card-section-title t-label-sm-heavy tc-cool-gray-02">
				{data.cardTitle}
			</div>
			<DCarousel
				ref={carouselRef}
				setCarouselInternal={setInternalCarouselData}
				responsiveSettings={isOneToOneCard ? oneToOneResponsiveCards : standardResponsiveCards}
				settings={
					isOneToOneCard
						? {
								cardsPerSection: 2,
								cardsToScroll: 1,
								draggable: true,
								gapBetweenCards: "2rem",
								prettyWrapping: true
							}
						: {
								cardsPerSection: shortCarousel ? 2 : 4,
								cardsToScroll: shortCarousel ? 1 : 3,
								draggable: true,
								gapBetweenCards: "2rem",
								prettyWrapping: true
							}
				}
			>
				{data.cards.map((card, i) => {
					return <StandardCard key={"card-carousel" + i} card={card} />;
				})}
			</DCarousel>
			<div className="carousel-card-featured-utility">
				{internalCarouselData && internalCarouselData.totalSections > 0 ? (
					<CarouselNavigation
						carouselRef={carouselRef}
						clickNumber={internalCarouselData.clickNumber}
						clicksToEnd={internalCarouselData.clicksToEnd}
						currentSection={internalCarouselData.currentSection}
						totalSections={internalCarouselData.totalSections}
					/>
				) : null}
			</div>
		</div>
	);
};

export default StandardCardCarousel;
